var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"divider-left"}),_c('div',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"divider-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }